import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { utils } from '@gisatcz/ptr-utils';
import { isMatch as _isMatch } from 'lodash';
import { forEachPeriodAndLayerInLayerRow } from './helpers';
import commonHelpers from '../../_common/helpers';
import mapTimelineSelectors from './selectors';
import mapsSelectors from '../../Maps/selectors';
import commonSelectors from '../../_common/selectors';
import mapsActions from '../../Maps/actions';
import periodsActions from '../../Periods/actions';
import dataSpatialRelationsActions from '../../Data/SpatialRelations/actions'; // ============ creators ===========

/**
 * Remove all map layers  defined in timeline layerRow
 * @param {string} mapKey
 * @param {Object} layerRow LayerRow definition
 * @returns
 */

var removeLayerRow = function removeLayerRow(mapKey, layerRow) {
  return function (dispatch, getState) {
    var state = getState();
    var mapLayers = mapsSelectors.getLayersStateByMapKey(state, mapKey);

    var removeLayerIfInMap = function removeLayerIfInMap(timelineLayer, timelineMapLayerDefinition) {
      var mapLayer = mapLayers === null || mapLayers === void 0 ? void 0 : mapLayers.find(function (l) {
        return _isMatch(l, timelineMapLayerDefinition);
      });
      var isInMap = !!mapLayer;

      if (isInMap) {
        dispatch(mapsActions.removeMapLayersByFilter(mapKey, timelineMapLayerDefinition));
      }
    };

    forEachPeriodAndLayerInLayerRow(state, layerRow, removeLayerIfInMap);
  };
};
/**
 * Change layer state in map state depends on defined behavior on layerRow.
 * Each layerRow in MapTimeline could have defined how or if layer state in Map should be controlled.
 * If layerRow.controlMapState is false, then nothing happens on click.
 * If layerRow.controlMapState is true, then layer visibility in map is changing on each click.
 * If layerRow.controlMapState is 'toggle', only one layer in row could be in Map. So other layers are removed.
 *
 * Separate property "layerRow.allowNonActiveLayer" define if it is possible to remove all layers from row.
 *
 * @param {Object} timelineLayerPeriodItem Timeline period with data about origin period.
 * @param {Object} timelineLayer Timeline Layer definition
 * @param {string} mapKey
 * @param {Object} layerRow MapTimeline row definition
 * @param {Array} layers Timeline Layers definitions
 * @returns
 */


var toggleTimelineLayer = function toggleTimelineLayer(timelineLayerPeriodItem, timelineLayer, mapKey, layerRow, layers) {
  return function (dispatch, getState) {
    var _timelineLayerPeriodI, _timelineLayerPeriodI2, _timelineLayerPeriodI3;

    var state = getState();
    var activeKeys = commonSelectors.getAllActiveKeys(state);

    var period = _objectSpread({}, timelineLayerPeriodItem !== null && timelineLayerPeriodItem !== void 0 && (_timelineLayerPeriodI = timelineLayerPeriodItem.origin) !== null && _timelineLayerPeriodI !== void 0 && _timelineLayerPeriodI.originPeriod ? {
      key: timelineLayerPeriodItem === null || timelineLayerPeriodItem === void 0 ? void 0 : (_timelineLayerPeriodI2 = timelineLayerPeriodItem.origin) === null || _timelineLayerPeriodI2 === void 0 ? void 0 : (_timelineLayerPeriodI3 = _timelineLayerPeriodI2.originPeriod) === null || _timelineLayerPeriodI3 === void 0 ? void 0 : _timelineLayerPeriodI3.key
    } : {});

    var timelineMapLayerDefinition = mapTimelineSelectors.getTimelineMapLayerPeriodDefinition(timelineLayer === null || timelineLayer === void 0 ? void 0 : timelineLayer.layerState, period === null || period === void 0 ? void 0 : period.key, activeKeys);
    var mapLayer = mapTimelineSelectors.getMapLayerByTimelineLayerAndPeriod(mapKey, timelineLayer, period);
    var isInMap = !!mapLayer;
    var mapLayers = mapsSelectors.getLayersStateByMapKey(state, mapKey);
    var expectedLayerZIndex = timelineLayer.mapZIndex;
    var newLayerZIndex = getMapZIndexForLayer(state, mapLayers, layers, expectedLayerZIndex);

    if (layerRow.controlMapState === false) {
      return;
    } else if (layerRow.controlMapState === 'toggle') {
      if (isInMap) {
        // click on active layer
        var preventRemoveLayer = layerRow.allowNonActiveLayer === false;

        if (!preventRemoveLayer) {
          dispatch(removeLayerRow(mapKey, layerRow));
        }
      } else {
        // click on non-active layer
        dispatch(removeLayerRow(mapKey, layerRow));
        dispatch(mapsActions.addMapLayerToIndex(mapKey, _objectSpread(_objectSpread(_objectSpread({}, timelineLayer.layerState), timelineMapLayerDefinition), {}, {
          key: utils.uuid()
        }), newLayerZIndex));
      }
    } else if (layerRow.controlMapState === true) {
      if (isInMap) {
        var layerIsLastInMap = getActiveLayersCountInRow(state, mapKey, layerRow) === 1;

        var _preventRemoveLayer = layerRow.allowNonActiveLayer === false && layerIsLastInMap;

        if (!_preventRemoveLayer) {
          dispatch(mapsActions.removeMapLayersByFilter(mapKey, timelineMapLayerDefinition));
        }
      } else {
        dispatch(mapsActions.addMapLayerToIndex(mapKey, _objectSpread(_objectSpread(_objectSpread({}, timelineLayer.layerState), timelineMapLayerDefinition), {}, {
          key: utils.uuid()
        }), newLayerZIndex));
      }
    } else {
      return;
    }
  };
};
/**
 * Ensure spatialRelation and all linked periods by filter.
 * @param {Object} filterByActive
 * @param {Object} filter
 * @param {Array} order
 * @param {Number} start
 * @param {Number} length
 * @returns
 */


var useRelationsForLayerRowItem = function useRelationsForLayerRowItem(filterByActive, filter, order, start, length) {
  return function (dispatch, getState) {
    var activeKeys = commonSelectors.getAllActiveKeys(getState());
    var fullFilter = commonHelpers.mergeFilters(activeKeys, filterByActive, filter);
    return dispatch(dataSpatialRelationsActions.ensureIndexed(fullFilter, order, start, length)).then(function () {
      var periodKeysFromRelations = mapTimelineSelectors.getPeriodKeysForFilteredSpatialRelations(getState(), filterByActive, filter, order, start, length);
      return dispatch(periodsActions.useKeys(periodKeysFromRelations));
    });
  };
}; // ============ actions ===========
// ============ helpers ===========

/**
 * Calculate all layers that are in the map from given layerRow definition and mapKey.
 * @param {Object} state
 * @param {string} mapKey
 * @param {Object} layerRow
 * @returns
 */


function getActiveLayersCountInRow(state, mapKey, layerRow) {
  var mapLayers = mapsSelectors.getLayersStateByMapKey(state, mapKey);
  var activeLayers = 0;

  var countActiveLayer = function countActiveLayer(timelineLayer, timelineMapLayerDefinition) {
    var mapLayer = mapLayers === null || mapLayers === void 0 ? void 0 : mapLayers.find(function (l) {
      return _isMatch(l, timelineMapLayerDefinition);
    });
    var isInMap = !!mapLayer;

    if (isInMap) {
      activeLayers++;
    }
  };

  forEachPeriodAndLayerInLayerRow(state, layerRow, countActiveLayer);
  return activeLayers;
}
/**
 * Calculate new map zIndex on the base of wanted "expectedLayerZIndex" which respects layers in map and theirs "expectedLayerZIndex".
 * Compare map layers and theirs "expectedLayerZIndex" with wanted "expectedLayerZIndex".
 * @param {Object} state
 * @param {Array} mapLayers Map Layers definitions
 * @param {Array} timelineLayers Timeline Layers definitions
 * @param {Number} expectedLayerZIndex ZIndex value defined external of map. This value define wanted zIndex due to rest of layers in timeline.
 * @returns
 */


function getMapZIndexForLayer(state) {
  var mapLayers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var timelineLayers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var expectedLayerZIndex = arguments.length > 3 ? arguments[3] : undefined;
  var indexes = new Set();

  var findMapLayerIndexes = function findMapLayerIndexes(timelineLayer, timelineMapLayerDefinition) {
    var mapLayer = mapLayers === null || mapLayers === void 0 ? void 0 : mapLayers.find(function (l) {
      return _isMatch(l, timelineMapLayerDefinition);
    });
    var isInMap = !!mapLayer;

    if (isInMap) {
      indexes.add(timelineLayer === null || timelineLayer === void 0 ? void 0 : timelineLayer.mapZIndex);
    }
  };

  timelineLayers.forEach(function (timelineLayerRow) {
    forEachPeriodAndLayerInLayerRow(state, timelineLayerRow, findMapLayerIndexes);
  });

  var lowerIndexesArr = _toConsumableArray(indexes).sort(function (a, b) {
    return a - b;
  }).filter(function (i) {
    return i < expectedLayerZIndex;
  });

  if (lowerIndexesArr.length === 0) {
    return 0;
  } else {
    return lowerIndexesArr.length;
  }
} // ============ export ===========


export default {
  toggleTimelineLayer: toggleTimelineLayer,
  useRelationsForLayerRowItem: useRelationsForLayerRowItem
};